/**
 * Created by RUSS_ on 15.05.2018
 */
import { getItem } from "./utils/local-storage-util";
import { COOKIE_PREFERENCES } from "./const/constants";
import { api } from "./managers/api-manager";
import {
  getConfigAsArrayJson,
  getCookieById
} from "./utils/cookie-config-helper";
import CookieConfig from "./const/default-cookies-config";
import { isEuUser } from "./utils/browser";
import { waitForBrowserInfo } from "./managers/browser-manager";

const cookieAccepted = getItem(COOKIE_PREFERENCES.COOKIE_ACCEPTED);
const cookieSettings = JSON.parse(getItem(COOKIE_PREFERENCES.COOKIE_SETTINGS));

console.log("Prefly RuSs.CiTy Cookie Manager Initialized", cookieSettings);
window.myTranslation = () => {
  return "";
};
api.isCookieAccepted = id => {
  return new Promise((resolve, reject) => {
    waitForBrowserInfo().then(answer => {
      if (isEuUser(answer.data.country)|| true) {
        resolve(
          cookieAccepted &&
            (cookieSettings &&
              getCookieById(cookieSettings, id) &&
              getCookieById(cookieSettings, id).accepted)
        );
      } else {
        resolve(
          !cookieAccepted ||
            (cookieSettings &&
              getCookieById(cookieSettings, id) &&
              getCookieById(cookieSettings, id).accepted)
        );
      }
    });
  });
};

api.getHtmlToAcceptCookie = id => {
  const defaultConfig = CookieConfig.generate();
  const asArray = getConfigAsArrayJson(defaultConfig);
  const cookie = getCookieById(asArray, id);
  return `<div style="text-align: center;"><div style="color: orangered;">You can see this area if you accept cookie: <b style="color: red; font-weight: bolder;">${
    cookie.name
  }</b></div><button class="btn btn-primary" onclick="RussCityCookieManager.showAcceptCookieDialog({'cookieId':'${id}'})">Accept Selected</button></div>`;
};



// WEBPACK FOOTER //
// ./src-cookie-manager/prefly.js